import BaseModelIssuance from "@/models/BaseModelIssuance.js";

export const GridConfig = {
	list: BaseModelIssuance.list,
	columns: BaseModelIssuance.columns,
	query: {
		batchQuery:true,
        filter : function(o){
            return o.WorkflowStatus == 'Pending' || o.WorkflowStatus == 'Processing' || o.WorkflowStatus == 'Error'
        },
		limit: 5000
	},
	grid: {
		gridId: 'issuanceGrid',
		height: 500,
		checkbox: true,
		edit: true,
		delete: true,
		document: true,
		groupable: true,
		actionsColumnWidth:110
	}
}

export const ToolbarConfig = {
	list: 'ToolBarItems',
	items: [{
			id: "btnApproveIssuance",
			type: "button",
			text: "Approve Issuance",
			showIcon: "toolbar",
			icon: "check-circle",
			attributes: {
				"class": "btn btn-primary float-right-btn"
			}
		},
		{
			id: "btnAddIssuance",
			type: "button",
			text: "Add Issuance",
			showIcon: "toolbar",
			icon: "plus-circle",
			attributes: {
				"class": "btn btn-secondary float-right-btn"
			}
		},
		{
			id:"btnBulkImportIssuance",
			type: "button",
			text: "Bulk Import",
			showIcon: "toolbar",
			icon:"upload",
			attributes: { 
				"class": "float-right-btn btn btn-tertiary" 
			},
		},
		{
			id: "btnBulkAttachment",
			type: "button",
			text: "Attach Documents",
			showIcon: "toolbar",
			icon: "attachment",
			attributes: {
				"class": "float-right-btn btn btn-light", "style":"background: #fff;"
			}
		}
	]
}

export const UnitClassUpdateConfig = {
	list: "UnitClass",
	columns: {
		Id: {
			dataName: "Id",
			type: "number"
		},
		UnitIssued: {
			dataName: "UnitIssued",
			type: "string"
		}
	},
	
};
